var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "list-holder" },
    [
      _c("table", { staticClass: "listtable" }, [
        _vm.named_fields && !_vm.is_empty
          ? _c("thead", [
              _c(
                "tr",
                [
                  _vm.value
                    ? _c("th", { staticClass: "list-select" })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.fields, function(col, fld) {
                    return _c("th", { class: "th-" + fld }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$fields.label(col)) +
                          "\n        "
                      )
                    ])
                  })
                ],
                2
              )
            ])
          : _vm._e(),
        _vm._v(" "),
        !_vm.is_empty
          ? _c(
              "tbody",
              _vm._l(_vm.list, function(item) {
                return _c(
                  "tr",
                  { class: { url: !!_vm.url } },
                  [
                    _vm.value
                      ? _c("td", { staticClass: "list-select" }, [
                          _c("i", {
                            class: { checked: _vm.value.includes(item.id) },
                            on: {
                              click: function($event) {
                                _vm.toggleValue(item.id)
                              }
                            }
                          })
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.fields, function(col, fld) {
                      return _c(
                        "td",
                        { class: "td-" + fld },
                        [
                          _vm.cellurl(col) && _vm.cellurl(col)(item)
                            ? [
                                _c(
                                  "router-link",
                                  { attrs: { to: _vm.cellurl(col)(item) } },
                                  [
                                    _c("Cell", {
                                      attrs: {
                                        name: fld,
                                        item: item,
                                        field: col
                                      },
                                      on: {
                                        updating: _vm.updating,
                                        updated: _vm.updated
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            : [
                                _c("Cell", {
                                  attrs: { name: fld, item: item, field: col },
                                  on: {
                                    updating: _vm.updating,
                                    updated: _vm.updated
                                  },
                                  nativeOn: {
                                    click: function($event) {
                                      _vm.$emit("clicked", item, col)
                                    }
                                  }
                                })
                              ]
                        ],
                        2
                      )
                    })
                  ],
                  2
                )
              })
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.named_fields && _vm.is_empty
          ? _c("tfoot", [
              _c("tr", [
                _c("td", { attrs: { colspan: _vm.fields_count } }, [
                  _vm._v(_vm._s(_vm._f("trans")("no_count")))
                ])
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.$slots.tfoot ? _c("tfoot", [_vm._t("tfoot")], 2) : _vm._e()
      ]),
      _vm._v(" "),
      _vm.paginate
        ? _c("Pages", {
            attrs: { pages: _vm.pages },
            model: {
              value: _vm.p,
              callback: function($$v) {
                _vm.p = $$v
              },
              expression: "p"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.loading ? _c("Loading", { staticClass: "absolute" }) : _vm._e(),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-41ffd0f1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41ffd0f1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/helpers/components/display/List.vue
// module id = null
// module chunks = 